import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { verifyStripeAccountApi } from "../../services/groups";
import { toastMessage } from "../../utils/toastMessage";

const StripeConnectAccount = () => {
  const navigate = useNavigate();
  const [searcQuery] = useSearchParams();

  const fetchData = async () => {
    try {
      const code = searcQuery.get("code");
      const _user = searcQuery.get("state");

      const {data, status} = await verifyStripeAccountApi({
        code,
        _user,
      });

      if( status === 200 ) {
        navigate("/");
        toastMessage("Stripe Acoount connected successfully", "success", "qwert2453");
      }

      console.log({ data, status });
    } catch (e) {
      console.log("Login:-", e.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return <div>Loading....</div>;
};

export default StripeConnectAccount;
